import { Center, Flex, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { General } from "./components/General";
import { ScopeThree } from "./components/ScopeThree";
import { Fragment, useState } from "react";
import { BlockHeader } from "../../../../components/BlockHeader";
import * as React from "react";
import { ConsumptionBasedScopeOne } from "./components/ConsumptionBasedScopeOne";
import { ConsumptionBasedScopeTwo } from "./components/ConsumptionBasedScopeTwo";
import { t } from "i18next";

function ConsumptionBasedRevenue({ data, submitAndReturnToList, setSubmitAndReturnToList, handleNavigationToList, isPreview }) {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Fragment>
      <Tabs colorScheme="customScheme" index={tabIndex} onChange={setTabIndex}>
        <Center>
          <TabList borderBottom="none">
            <Tab isDisabled={isPreview ? false : tabIndex !== 0}
                 _focus={{ boxShadow: "none" }}>{t("supplierQuestionnaire.revenueTabs.general")}</Tab>
            <Tab isDisabled={isPreview ? false : tabIndex !== 1}
                 _focus={{ boxShadow: "none" }} marginInline={8}>
              {`${t("supplierQuestionnaire.revenueTabs.scope")} 1`}
            </Tab>
            <Tab isDisabled={isPreview ? false : tabIndex !== 2}
                 _focus={{ boxShadow: "none" }} marginInline={8}>
              {`${t("supplierQuestionnaire.revenueTabs.scope")} 2`}
            </Tab>
            <Tab isDisabled={isPreview ? false : tabIndex !== 3}
                 _focus={{ boxShadow: "none" }} marginInline={8}>
              {`${t("supplierQuestionnaire.revenueTabs.scope")} 3`}
            </Tab>
          </TabList>
        </Center>
        <TabPanels>
          <TabPanel padding="0">
            <Flex flexDirection="column" paddingBlock="6">
              <BlockHeader
                title={t("supplierQuestionnaire.general.title")}
                description={t("supplierQuestionnaire.general.subtitle")}
                paddingBottom={8}
              />
              <General
                isTabActive={tabIndex === 0}
                defaultValues={data}
                handleTabChange={setTabIndex}
                isPreview={isPreview}
                returnToListRequested={submitAndReturnToList}
                declineReturnToListRequest={() => setSubmitAndReturnToList(false)}
                returnToList={handleNavigationToList}
              />
            </Flex>
          </TabPanel>
          <TabPanel padding="0">
            <Flex flexDirection="column" paddingBlock="6">
              <BlockHeader
                title={t("organizationQuestionnaire.scope1.info.title")}
                description={t("organizationQuestionnaire.scope1.info.subtitle")}
                paddingBottom={8} />
              <ConsumptionBasedScopeOne
                isTabActive={tabIndex === 1}
                defaultValues={data}
                handleTabChange={setTabIndex}
                isPreview={isPreview}
                returnToListRequested={submitAndReturnToList}
                returnToList={handleNavigationToList}
              />
            </Flex>
          </TabPanel>
          <TabPanel padding="0">
            <Flex flexDirection="column" paddingBlock="6">
              <BlockHeader
                title={t("organizationQuestionnaire.scope2.info.title")}
                description={t("organizationQuestionnaire.scope2.info.subtitle")}
                paddingBottom={8} />
              <ConsumptionBasedScopeTwo
                isTabActive={tabIndex === 2}
                defaultValues={data}
                handleTabChange={setTabIndex}
                isPreview={isPreview}
                returnToListRequested={submitAndReturnToList}
                returnToList={handleNavigationToList}
              />
            </Flex>
          </TabPanel>
          <TabPanel padding="0">
            <Flex flexDirection="column" paddingBlock="6">
              <BlockHeader
                title={t("supplierQuestionnaire.scopeThree.title")}
                description={t("supplierQuestionnaire.scopeThree.subtitle")}
                paddingBottom={8} />
              <ScopeThree
                isTabActive={tabIndex === 3}
                id={data.id}
                categories={data.revenue?.categories ?? {}}
                consumptionBasedData={data.revenue?.consumptionBased ?? {}}
                questionnaireType={data.questionnaireType}
                isReviewModalUsed={false}
                handleTabChange={setTabIndex}
                isPreview={isPreview}
                returnToListRequested={submitAndReturnToList}
                returnToList={handleNavigationToList}
              />
            </Flex>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Fragment>
  );
}

export default ConsumptionBasedRevenue;